import Modal from './Modal';
import { TerminalButton } from './TerminalButton';
import { useAuthenticatedUser } from '../../contexts/AuthContext';

interface LogoutConfirmationDialogProps {
	isOpen: boolean;
	onClose: () => void;
}

export default function LogoutConfirmationDialog(props: LogoutConfirmationDialogProps) {
	const auth = useAuthenticatedUser();

	const handleConfirm = () => {
		auth.logout();
		props.onClose();
	};

	return (
		<Modal isOpen={props.isOpen} onClose={props.onClose}>
			<div class="space-y-4" data-testid="logout-dialog">
				<div class="space-y-2">
					<h2 class="text-lg font-bold text-green">Confirm Logout</h2>
					<p class="text-green">Are you sure you want to sign out of your account?</p>
				</div>
				<div class="flex justify-end space-x-3">
					<TerminalButton action={props.onClose} keyBinding="ESC" text="Cancel" />
					<TerminalButton action={handleConfirm} keyBinding="ENTER" text="Logout" />
				</div>
			</div>
		</Modal>
	);
}
